<template>
  <el-dialog
    title="课程配置"
    :visible.sync="dialogVisible"
    width="40%"
    class="form"
  >
    <el-form ref="form" :model="form" label-width="80px" :rules="rules">
      <el-form-item label="背景图片(1903*919):" prop="videoBackgroundUrl">
        <el-upload
          class="avatar-uploader"
          ref="upload"
          action
          :show-file-list="false"
          :http-request="videoBackgroundUrlFileUploadRequest"
        >
          <el-image
            :src="form.videoBackgroundUrl"
            v-if="form.videoBackgroundUrl"
            class="avatar"
            fit="cover"
          ></el-image>
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-form-item>
      <el-form-item label="标题图片(1200*319):" prop="backgroundUrl">
        <el-upload
          class="avatar-uploader"
          ref="upload"
          action
          :show-file-list="false"
          :http-request="imageFileUploadRequest"
        >
          <el-image
            :src="form.backgroundUrl"
            v-if="form.backgroundUrl"
            class="avatar"
            fit="cover"
          ></el-image>
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-form-item>
      <!-- <el-form-item label="类型:" prop="type">
        <el-radio v-model="form.type" :label="1">文本</el-radio>
        <el-radio v-model="form.type" :label="2">链接</el-radio>
      </el-form-item> -->
      <!-- <el-form-item label="文本:" v-if="form.type == 1" prop="content">
        <el-input
          type="textarea"
          v-model="form.content"
          style="width: 80%"
          :autosize="{ minRows: 6, maxRows: 6 }"
        ></el-input>
      </el-form-item> -->
      <el-form-item label="html文件:" prop="url">
        <el-input
          placeholder="请输入内容"
          v-model="form.url"
          class="input-with-select"
          style="width: 80%"
        >
        </el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="submitForm()">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { uploadOSS } from "../../upload/upload";
export default {
  name: "configeCourse",
  data() {
    return {
      dialogVisible: false,
      form: {
        subjectId: "",
        backgroundUrl: "",
        content: "",
        type: 2,
        url: "",
        id: "",
      },
      rules: {
        // backgroundUrl: [{ required: true, message: "请上传背景图片", trigger: "change" }],
        content: [{ required: true, message: "请输入文本", trigger: "blur" }],
        url: [{ required: true, message: "请输入链接地址", trigger: "blur" }],
      },
    };
  },
  methods: {
    getDetail(subjectId) {
      this.form = {
        subjectId: "",
        backgroundUrl: "",
        videoBackgroundUrl: "",
        content: "",
        type: 2,
        url: "",
        id: "",
      };
      this.form.subjectId = subjectId;
      this.api.subjectCourse.getSubjectConfig({ subjectId }).then((res) => {
        if (res.data) {
          this.form = res.data;
        } else {
        }
      });
    },
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let apiName = "addSubjectConfig";
          if (this.form.id) {
            apiName = "updateSubjectConfig";
          }
          this.api.subjectCourse[apiName](this.form).then(() => {
            this.dialogVisible = false;
          });
        }
      });
    },
    // 获取阿里云数据
    async getAliyun() {
      this.api.upload().then((result) => {
        this.Aliyun = result.data;
      });
    },
    imageFileUploadRequest(file) {
      const isJPG = file.file.type.indexOf("image") > -1;
      if (!isJPG) {
        this.$message.error("上传文件必须是图片哦!");
        return;
      }
      if (file.file.size / 1024 / 1024 > 100) {
        this.$message.error("图片大小不能超过100M");
      } else {
        uploadOSS(file, "image").then((result) => {
          this.form.backgroundUrl = result;
        });
      }
    },
    videoBackgroundUrlFileUploadRequest(file) {
      const isJPG = file.file.type.indexOf("image") > -1;
      if (!isJPG) {
        this.$message.error("上传文件必须是图片哦!");
        return;
      }
      if (file.file.size / 1024 / 1024 > 100) {
        this.$message.error("图片大小不能超过100M");
      } else {
        uploadOSS(file, "image").then((result) => {
          this.form.videoBackgroundUrl = result;
        });
      }
    },
  },
  mounted() {
    this.getAliyun();
  },
};
</script>
<style lang="less" scoped>
.form {
  .avatar-uploader {
    /deep/ .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
    }
    /deep/ .el-upload:hover {
      border-color: #409eff;
    }
    .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 150px;
      height: 150px;
      line-height: 150px;
      text-align: center;
    }
    .avatar {
      width: 150px;
      height: 150px;
      display: block;
    }
  }
  /deep/ .el-input-group__append {
    background: #409eff;
    color: #fff;
    border-color: #409eff;
  }
  /deep/ .el-dialog__footer {
    text-align: right;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/classroom/configCourse.vue